/**
 * Wait before retrying a failed config poll: the base wait doubled on each consecutive
 * failure (1 s, 2 s, 4 s, …), never longer than the normal polling interval, plus up to 20%
 * jitter. A fixed 1 s retry from every open tab turned an API outage into a request flood
 * the moment it came back; capped at the polling interval, an outage is still noticed and
 * recovery still seen within one normal poll.
 *
 * @param retryCount 1 for the first retry, as rxjs `retry({ delay })` passes it
 */
export function configRetryDelay(retryCount: number, baseMs: number, capMs: number, random: () => number = Math.random): number {
  const backoff = Math.min(baseMs * 2 ** Math.max(0, retryCount - 1), Math.max(baseMs, capMs));
  return Math.round(backoff * (1 + 0.2 * random()));
}
